import React from 'react'
import { Spinner } from 'react-bootstrap'

function PreviewLoader({ length = 6, getConsistentWidth }) {
    return [
        ...Array(length).fill().map((_, index) => (
            <li key={index} className="vendor">
                <div className="d-sm-flex align-items-center">
                    <div className="avatar avatar-xs" style={{ minWidth: '20px' }}>
                        <div className="avatar-img">
                            <Spinner animation="border" role="status" style={{ width: '20px', height: '20px', color: 'rgb(215 219 223)' }}>
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    </div>
                    <div className="ms-2 fs-sm">
                        <div
                            className="placeholder-glow"
                            style={{ height: 13, width: `${getConsistentWidth(index)}`, backgroundColor: 'rgb(215 219 223)' }}
                        ></div>
                    </div>
                </div>
            </li>
        ))
    ]
}

export default PreviewLoader
